import { render } from "./HomePage.vue?vue&type=template&id=c6bdc170&ts=true"
import script from "./HomePage.vue?vue&type=script&lang=ts&setup=true"
export * from "./HomePage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/HomePage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c6bdc170"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c6bdc170', __exports__)) {
    api.reload('c6bdc170', __exports__)
  }
  
  module.hot.accept("./HomePage.vue?vue&type=template&id=c6bdc170&ts=true", () => {
    api.rerender('c6bdc170', render)
  })

}


export default __exports__